/* Misy Experience Layer JS (2026-07-07)
   正本パターン: sections/misy-brand-story.liquid のIO実装
   設計: TARGETS/SWEEPSが空なら何もしない（Phase 1=空、Phase 2/3で有効化）
   安全: reduced-motion時は即return / IO非対応は即return / ラップ失敗しても本文は常に可視 */
(function () {
  'use strict';

  /* Phase 2で有効化: line-reveal対象（Phase 0実測のセレクタのみ。発明禁止） */
  var TARGETS = [
    '[id*="__choice-guide-top"] .mcg2__title',
    '[id*="__trust-badges"] h2',
    '[id*="__ranking-section"] h2',
    '[id*="__faq-section"] h2',
    '[id*="__journal-promo"] h2',
    '[id*="__best-sellers"] .misy-bs__h',
    '[id*="__v10-more-products"] h2',
    '[id*="__bottom-hook"] .bh-title',
    '[id*="__image-with-text-overlay-1"] .misy-maf__h'
  ];

  /* Phase 3で有効化: sweep対象（配給制・最大2） */
  var SWEEPS = [];

  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  if (!TARGETS.length && !SWEEPS.length) return;

  document.documentElement.classList.add('msx-js');

  function wrapHeading(el) {
    if (el.dataset.msxWrapped) return;
    el.dataset.msxWrapped = '1';
    var inner = document.createElement('span');
    while (el.firstChild) inner.appendChild(el.firstChild);
    var ln = document.createElement('span');
    ln.className = 'msx-ln';
    ln.appendChild(inner);
    el.appendChild(ln);
  }

  function init() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('msx-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18 });

    TARGETS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        try { wrapHeading(el); el.classList.add('msx-in-target'); io.observe(el); } catch (err) {}
      });
    });

    SWEEPS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        try { el.classList.add('msx-sweep'); io.observe(el); } catch (err) {}
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
